import { CareerMotivationModal } from '@findy-code/yuffie/shared/modal/career-motivation-modal';
import { Text } from '@findy-code/yuffie/ui/text';
import { useState } from 'react';

import { CareerMotivationButton } from './career-motivation-button.component';

type Props = {
  motivationId?: number;
};

export const CareerMotivationButtonWithModalContainer = ({
  motivationId,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ textAlign: 'center' }}>
      <Text
        font="heading-xs"
        style={{
          display: 'inline-block',
          marginRight: 'var(--fds-spacing-200, 8px)',
        }}
      >
        転職意欲
      </Text>
      <CareerMotivationButton
        motivationId={motivationId}
        onClick={() => setIsOpen(true)}
      />
      <CareerMotivationModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};
